import { useStore } from '@tanstack/react-form';

import { useFieldContext, useFormContext } from '@/library/form/contexts';

/** Whether the current field's errors should show: it is invalid and was touched or the form was submitted. */
export const useFieldInvalid = (): boolean => {
  const field = useFieldContext<unknown>();
  const form = useFormContext();
  const submitAttempted = useStore(form.store, (state) => state.submissionAttempts > 0);
  return (field.state.meta.isTouched || submitAttempted) && !field.state.meta.isValid;
};
